import { render, staticRenderFns } from "./AdminDeviceTypeSettings.vue?vue&type=template&id=5c6791c5&"
import script from "./AdminDeviceTypeSettings.vue?vue&type=script&lang=ts&"
export * from "./AdminDeviceTypeSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports